import { Directive, HostListener } from "@angular/core";
import { UtilityService } from "../services/utility.service";

@Directive({
  selector: "[appNumberConversion]",
})
export class NumberConversionDirective {
  constructor(private uc: UtilityService) {}

  @HostListener("keyup", ["$event"])
  keyEvent(event) {
    let org = event.target.value;
    let cc = this.uc.numberMtoE(org);
    event.preventDefault();
    event.stopPropagation();
    if (cc && cc.length > 0) {
      event.target.value = cc;
    }
  }
}
